// tslint:disable-next-line: max-line-length
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-avatar-upload',
  templateUrl: './avatar-upload.component.html',
  styleUrls: ['./avatar-upload.component.scss']
})
export class AvatarUploadComponent implements OnInit, OnChanges {

  @ViewChild('content') content: ElementRef;
  @Output() avatarChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() avatarRemoved: EventEmitter<any> = new EventEmitter<any>();
  @Input() imageSrc: string;
  @Input() edit = true;
  @Input() delete = false;
  @Input() configs = {isActive: false};
  @Input() originalImageSrc: string;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  canvasRotation = 0;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  file: File;
  IMG_TYPE = 'image/png';
  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = true;

    this.matIconRegistry.addSvgIcon(
      `icon_del`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/images/common/trash.svg')
    );
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.originalImageSrc) {
      this.imageSrc = this.originalImageSrc;
    }
  }

  open(content: any): void {
    this.modalService.open(content);
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.file = event.target.files[0];
    this.modalService.open(this.content);
  }
  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
  }
  imageLoaded(event): void {
    // show cropper
    this.showCropper = true;
  }

  loadImageFailed(event: any): void {
  }

  onClose(): void {
    this.transform = {};
  }

  onSetAvatar(): void {
    this.imageSrc = this.croppedImage;
    const b64Img = this.croppedImage.replace(/^data:image\/(png|jpg);base64,/, '');
    const imageBlob: Blob = this.b64toBlob(b64Img, '', 1024);
    const imageFile: File = new File([imageBlob], this.file.name, { type: this.IMG_TYPE });
    this.avatarChanged.emit(imageFile);
  }

  removeAvatar(): void {
    this.imageSrc = this.originalImageSrc;
    this.avatarRemoved.emit();
  }

  b64toBlob(b64Data, contentType?, sliceSize?): any {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
